import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import SendPage from './components/SendPage';
import ReceivePage from './components/ReceivePage';
import AIAssistant from './components/AIAssistant';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

function App() {
  const [showAIAssistant, setShowAIAssistant] = useState(false);

  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-gradient-to-br from-indigo-50 via-white to-purple-50">
        <Navbar />
        
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/send" element={<SendPage />} />
            <Route path="/receive/:roomId?" element={<ReceivePage />} />
          </Routes>
        </main>

        <Footer />

        {/* AI Assistant Toggle Button */}
        <button
          onClick={() => setShowAIAssistant(!showAIAssistant)}
          className="fixed bottom-6 right-6 bg-indigo-600 text-white rounded-full p-4 shadow-lg hover:bg-indigo-700 transition-all hover:scale-110 z-40"
          title="AI Assistant"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
          </svg>
        </button>

        {/* AI Assistant Component */}
        {showAIAssistant && (
          <AIAssistant onClose={() => setShowAIAssistant(false)} />
        )}
      </div>
    </Router>
  );
}

export default App;
